import { render, staticRenderFns } from "./SalesTable.vue?vue&type=template&id=66e2084c"
import script from "./SalesTable.vue?vue&type=script&lang=js"
export * from "./SalesTable.vue?vue&type=script&lang=js"
import style0 from "./SalesTable.vue?vue&type=style&index=0&id=66e2084c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports